import { createDocValueStore } from './docStore';

// Which colour/material submodel the user is working on, shared across phases. Phase 2
// (the context row + cover) and Phase 5 (the video grounding) read and write this one
// per-document value, so switching the dropdown in one moves the other with it. The value
// is a submodel's ID (its listing link's uuid — see listingStore), '' when none is chosen
// yet. The id and not the label: a label is the merchant's wording, it moves when a
// listing is re-read, and everything filed under a moving key comes back unmatched.
//
// Kept out of doc-state on purpose: it is a view preference, not an answer about the
// manual — it needn't survive to the other admin or a reload, only stay consistent
// between the two phases while the tab is open.
const store = createDocValueStore<string>('');

export const useSubmodelFilter = store.useValue;
// For the callers that read it OUTSIDE a render — a run deciding which pictures it
// is about, which is not a subscription.
export const getSubmodelFilter = store.get;
export const setSubmodelFilter = store.set;
